module.exports = __webpack_public_path__ + "static/media/OutliersQ7_2.95b22cd5.svg";